import ConfirmAction from "./styles";

export default ConfirmAction;
